export default "__VITE_ASSET__Bi2iHmDS__"